import React from "react";

import {
  DesktopFilterGroup,
  DesktopFilterItem,
  DesktopFilters,
} from "../../components/molecules/desktopFilter";
import { ListEventsFilterForm } from "./PageListEvents";
import { UseFormReturn } from "../../form";
import { TextInput } from "../../components/molecules/textInput";
import { Button } from "../../components/atoms/button";
import {
  EventCategoryItemFragment,
  IndustryItemFragment,
} from "../../generated/graphql";
import { DropDown, withNullOption } from "../../components/molecules/dropDown";
import { areasDropDownOptions } from "../../common";
import styles from "./EventDesktopFilters.module.scss";
import { CheckBoxGroup } from "../../components/molecules/checkBoxGroup";
import { MultiSelect } from "../../components/molecules/multiselect";
import { CalendarInput } from "../../components/molecules/calendar";

interface Props {
  clearFields: () => void;
  onSubmit: () => void;
  industries: IndustryItemFragment[];
  form: UseFormReturn<ListEventsFilterForm>;
  eventCategories: Array<EventCategoryItemFragment>;
}

export function EventDesktopFilters(props: Props) {
  const { clearFields, industries, onSubmit, form, eventCategories } = props;
  const { field } = form;

  return (
    <>
      <DesktopFilters>
        <DesktopFilterGroup>
          <DesktopFilterItem filterLabel="イベント名・企業名">
            <TextInput {...field("title")} className={styles.filterInput} />
          </DesktopFilterItem>
          <DesktopFilterItem filterLabel="開催期間">
            <CalendarInput
              allowPast
              noClear
              onChange={({ endDate, startDate }) => {
                field("endDate").setValue(endDate);
                field("startDate").setValue(startDate);
              }}
              value={{
                endDate: field("endDate").value,
                startDate: field("startDate").value,
              }}
            />
          </DesktopFilterItem>
        </DesktopFilterGroup>
        <DesktopFilterGroup>
          <DesktopFilterItem filterLabel="エリア" halfWidth>
            <DropDown
              {...withNullOption(areasDropDownOptions, "全て")}
              {...field("area")}
              type="arrange"
            />
          </DesktopFilterItem>
          <DesktopFilterItem filterLabel="業界" halfWidth>
            <MultiSelect
              options={industries}
              {...field("industries")}
              toKey={(i) => i.id}
              renderLabel={(i) => i.name}
              inputClass={styles.industryWidth}
              type="medium"
            />
          </DesktopFilterItem>
        </DesktopFilterGroup>
        <DesktopFilterGroup>
          <DesktopFilterItem filterLabel="イベント種別">
            <CheckBoxGroup
              checkboxClassName={styles.categoryCheckbox}
              labelClassName={styles.categoryCheckboxLabel}
              checkedClassName={styles.categoryCheckboxChecked}
              options={eventCategories.sort(
                (c1, c2) => c1.displayOrder - c2.displayOrder,
              )}
              {...field("eventCategories")}
              renderLabel={(c) => {
                if (c.name === "本部イベント") {
                  return "en-courage主催イベント";
                } else if (c.name === "支部イベント") {
                  return "メンター主催イベント";
                } else {
                  return c.name;
                }
              }}
              toKey={(c) => c.id}
            />
          </DesktopFilterItem>
        </DesktopFilterGroup>
      </DesktopFilters>
      <div className={styles.actionsContainer}>
        <Button
          className={styles.clearFields}
          size="midSmall"
          color="secondary"
          onClick={clearFields}
        >
          クリア
        </Button>
        <Button size="midSmall" onClick={onSubmit}>
          絞り込む
        </Button>
      </div>
    </>
  );
}
